import React from 'react';
import {
  Dialog,
  FormControl,
  DialogTitle,
  DialogActions,
  IconButton,
  DialogContent,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Gmail from 'assets/images/gmail.png';
import WhatsApp from 'assets/images/whatsApp.png';
import Close from '@mui/icons-material/Close';

import './ReferInspectSmart.scss';

type ReferInspectSmartProps = {
  open: boolean;
  onClose: () => void;
};

export const ReferInspectSmart: React.FC<ReferInspectSmartProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="refer-inspect-smart"
      PaperProps={{
        style: {
          padding: 0,
          minWidth: 300,
        },
      }}
    >
      <DialogActions className="dialog-actions d-flex justify-content-between w-100">
        <DialogTitle className="p-1" color="inherit">
          {t('menu_refer')}
        </DialogTitle>
        <IconButton className="close-btn" onClick={onClose}>
          <Close color="inherit" />
        </IconButton>
      </DialogActions>
      <DialogContent>
        <Typography variant="h6" className="text-center">
          {t('modal_title_invite_your_connection')}
        </Typography>
        <FormControl className="d-flex  w-100 justify-content-center flex-row mb-3">
          <IconButton title="WhatsApp" className="mx-2">
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me?text=Hello!%0A%0ANamaste%2C%0A%0AI%20am%20using%20a%20very%20powerful%20digital%20tool%20InspectSmart%20for%20my%20on-site%20inspection.%0A%0AIt%20facilitates%20construction%20sites%20and%20assets%20with%20their%20digital%20tool%20which%20ease%20the%20on-site%20inspections%20process%20%26%20management.%0A%0AInspectsmart%20is%20used%20in%20three%20simple%20steps-%0A%0A1)%20Setup%20your%20project%2C%0A2)%20On-Site%20Inspection%2C%0A3)%20Reports%20%26%20Analytics%0A%0AJoin%20Now%3A%20https%3A%2F%2Finspectsmart.netlify.app%2F`}
            >
              <img alt="whats-app" src={WhatsApp} />
            </a>
          </IconButton>
          <IconButton title="Gmail" className="mx-2">
            <a
              className="desktop"
              target="_blank"
              rel="noreferrer"
              href={`https://mail.google.com/mail/?view=cm&fs=1&su=InspectSmart | On-site Construction inspection made digital&body=Hello!%0A%0ANamaste%2C%0A%0AI%20am%20using%20a%20very%20powerful%20digital%20tool%20InspectSmart%20for%20my%20on-site%20inspection.%0A%0AIt%20facilitates%20construction%20sites%20and%20assets%20with%20their%20digital%20tool%20which%20ease%20the%20on-site%20inspections%20process%20%26%20management.%0A%0AInspectsmart%20is%20used%20in%20three%20simple%20steps-%0A%0A1)%20Setup%20your%20project%2C%0A2)%20On-Site%20Inspection%2C%0A3)%20Reports%20%26%20Analytics%0A%0AJoin%20Now%3A%20https%3A%2F%2Finspectsmart.netlify.app%2F`}
            >
              <img alt="whats-app" src={Gmail} />
            </a>
            <a
              className="mobile"
              href="mailto:?subject=InspectSmart | On-site Construction inspection made digital&body=Hello!%0A%0ANamaste%2C%0A%0AI%20am%20using%20a%20very%20powerful%20digital%20tool%20InspectSmart%20for%20my%20on-site%20inspection.%0A%0AIt%20facilitates%20construction%20sites%20and%20assets%20with%20their%20digital%20tool%20which%20ease%20the%20on-site%20inspections%20process%20%26%20management.%0A%0AInspectsmart%20is%20used%20in%20three%20simple%20steps-%0A%0A1)%20Setup%20your%20project%2C%0A2)%20On-Site%20Inspection%2C%0A3)%20Reports%20%26%20Analytics%0A%0AJoin%20Now%3A%20https%3A%2F%2Finspectsmart.netlify.app%2F"
            >
              <img alt="whats-app" src={Gmail} />
            </a>
          </IconButton>
        </FormControl>
      </DialogContent>
    </Dialog>
  );
};
